import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { changeInvoiceFilter, fetchInvoices } from '../actions';
import { selectInvoiceFilter } from '../selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const FiltersWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: start;
  align-items: center;
  // padding: 12px 0;
  width: 100%;
  flex-wrap: wrap;
`;

const FilterLabel = styled.div`
  background-color: var(--color-new-primary);
  color: var(--color-new-white);

  font-size: 12px;
  padding: 4px 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 5px;
`;

const DeleteFilterButton = styled.div`
  cursor: pointer;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ClearButton = styled.span`
  font-weight: bold;
  font-size: 12px;
  color: #df4074;
  text-decoration: underline;
  cursor: pointer;
`;

/* eslint-disable react/prefer-stateless-function */
class FiltersCloudComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  deleteFilter = filterName => {
    this.props.changeFilter(filterName, null);
  };

  clearAllFilters = () => {
    this.props.changeFilter('clear', null);
  };

  render() {
    const filtersList = Object.entries(this.props.filter).filter(
      entry => entry[0] !== 'offset' && entry[0] !== 'limit' && !!entry[1],
    );
    console.log('Filter: ', filtersList);
    const filterName = name => this.lblStr(`invoice.filter.${name}`);
    const filterValue = value => {
      if (value?.name) return value?.name;
      if (value === 'false' || value == '0' || value === 'invoice') return 'no';
      if (value === 'true' || value == '1' || value === 'credit') return 'yes';
      return value;
    };
    return (
      <FiltersWrapper>
        {filtersList?.map(filter => (
          <FilterLabel key={filter[0]}>
            {`${filterName(filter[0])}: ${filterValue(filter[1])}`}
            <DeleteFilterButton onClick={() => this.deleteFilter(filter[0])}>
              <FontAwesomeIcon icon={faTimes} />
            </DeleteFilterButton>
          </FilterLabel>
        ))}
        {!!filtersList.length && (
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.clearAllFilters}>
            <FontAwesomeIcon icon={faTimes} />
          </ButtonComponent>         )}
      </FiltersWrapper>
    );
  }
}

FiltersCloudComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectInvoiceFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(fetchInvoices());
    },
    changeFilter: (name, value) => {
      dispatch(changeInvoiceFilter(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const FiltersCloud = compose(withConnect, withRouter, injectIntl)(FiltersCloudComp);
